import { Injectable } from '@angular/core';
import { analyticsConfig } from '../config/analytics.config';

/**
 * Inicializa el dataLayer para GTM (Google Tag Manager).
 * GTM se carga desde index.html; este servicio solo asegura que dataLayer exista
 * antes de que los componentes emitan eventos.
 */
@Injectable({ providedIn: 'root' })
export class AnalyticsInitService {
  private isInitialized = false;

  initializeAnalytics(): void {
    if (this.isInitialized || !analyticsConfig.enabled) {
      return;
    }

    (window as any).dataLayer = (window as any).dataLayer || [];

    if (analyticsConfig.debug) {
      console.log('[Analytics] GTM dataLayer initialized', {
        env: analyticsConfig.environmentName
      });
    }

    this.isInitialized = true;
  }

  isAnalyticsEnabled(): boolean {
    return analyticsConfig.enabled;
  }

  isDebugMode(): boolean {
    return analyticsConfig.debug;
  }

  getMeasurementId(): string {
    return analyticsConfig.measurementId;
  }
}
